import { render, staticRenderFns } from "./WatchForm.vue?vue&type=template&id=1a20cc9a"
import script from "./WatchForm.vue?vue&type=script&lang=js"
export * from "./WatchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports